export default __webpack_public_path__ + "static/media/door_lighter.1b881c0f.svg";